import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AppInner } from './App';
import { SSRDataContext } from './lib/ssr-data';
import type { SSRData } from './lib/ssr-data';
import './index.css';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Could not find root element to mount to');
}

// Read SSR data injected by the server (if any).
// This ensures hydration matches the server-rendered output.
const ssrData: SSRData = window.__SSR_DATA__ || {};
// Clean up global after reading — it's only needed for initial hydration
delete window.__SSR_DATA__;

// In production, the server renders HTML into #root — hydrate it.
// In dev mode (no SSR), #root is empty — do a full client render.
if (rootElement.childElementCount > 0) {
  ReactDOM.hydrateRoot(
    rootElement,
    <React.StrictMode>
      <BrowserRouter>
        <SSRDataContext.Provider value={ssrData}>
          <AppInner />
        </SSRDataContext.Provider>
      </BrowserRouter>
    </React.StrictMode>,
  );
} else {
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <BrowserRouter>
        <AppInner />
      </BrowserRouter>
    </React.StrictMode>,
  );
}
